// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 76 ? "common" : chunkId) + "." + {"20":"41d5bc78","76":"450f5c79","241":"da6aa457","256":"c595df3c","409":"77bcc038","986":"48186150","989":"32797a83"}[chunkId] + ".chunk.js";
};